import React from 'react';
import CircularProgress from 'material-ui/Progress/CircularProgress';

const ProgressCircle =(props)=> {
    const { classes,size } = props;
    return (
        <div>
            <CircularProgress className='progress-circle'  size={size} />
        </div>
    );
};

export default ProgressCircle;